import { type AgreementListResponse, fetchAgreements } from '../../services/agreement';
import { type CaseListResponse, fetchCases } from '../../services/case';
import { type AssetListResponse, fetchAssetListByProductCategory } from '../../services/getAssetListByProductCategory';
import { fetchAgreementsBySite, fetchSites, type SiteListResponse } from '../../services/site';
import { fetchSubscriptions, type SubscriptionListResponse } from "../../services/subscriptions";
import { fetchUsers, type UserListResponse } from "../../services/usersManagement";
import { fetchRoles, Role } from '../UserManagement/service/userManagement.service';


const ASSET_FUNCTION_MAP: Record<number, string> = {
  1: 'GetMicroSCADAAssets',
  2: 'GetIEDAssets',
  3: 'GetRTUAssets',
  4: 'GetWirelessAssets',
  6: 'GetGPQSSAssets',
  13: 'GetHVAssets',
  14: 'GetHVAssets',
  15: 'GetHVAssets',
  16: 'GetHVAssets',
  17: 'GetHVAssets',
  18: 'GetHVAssets',
  19: 'GetTransformerAssets',
  20: 'GetTransformerAssets',
  21: 'GetTransformerAssets',
  22: 'GetTransformerAssets',
  23: 'GetESSAAssets',
  24: 'GetTransformerAssets',
};

interface CommonParams {
  top?: number;
  skip?: number;
  filter: string;
}

type SectionDataResponse = AgreementListResponse | CaseListResponse | SiteListResponse | AssetListResponse | SubscriptionListResponse | UserListResponse | Role[] | null | undefined;

export const fetchSectionData = async (
  sectionType: string | undefined,
  commonParams: CommonParams,
  selectedFilter: string,
): Promise<SectionDataResponse> => {
  switch (sectionType) {
    case 'relatedSites': {
      const encompassAgreementId = window.location.pathname.split('/').filter(Boolean).pop() ?? '';
      return fetchSites({ ...commonParams, encompassAgreementId });
    }
    case 'relatedCases': {
      const serviceAgreementId = window.location.pathname.split('/').filter(Boolean).pop() ?? '';
      return fetchCases({
        ...commonParams,
        kind: 'CompanyCases',
        relatedFilter: `((ServiceAgreement eq '${serviceAgreementId}'))`,
      });
    }
    case 'cases':
      return fetchCases({ ...commonParams, kind: selectedFilter });
    case 'agreements':
      return fetchAgreements(commonParams);
    case 'agreementsBySite': {
      const siteId = window.location.pathname.split('/').filter(Boolean).pop() ?? '';
      return fetchAgreementsBySite(siteId, { ...commonParams });
    }
    case 'assets': {
      const urlParams = new URLSearchParams(window.location.search);
      const categoryId = parseInt(urlParams.get('product-category-id') ?? '0', 10);
      const functionName = ASSET_FUNCTION_MAP[categoryId];
      if (!functionName) return null;
      return fetchAssetListByProductCategory({
        ...commonParams,
        functionName,
        categoryId,
        searchText: commonParams.filter,
      });
    }
    case 'subscriptions':
      return fetchSubscriptions({ ...commonParams });
    case 'userManagement':
      return fetchUsers();
    case 'userManagementRoles':
      return fetchRoles();
    default:
      return undefined;
  }
};
